import { CheckCircle2, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";

// Success state after a password is set: large, high-contrast, readable on a phone.
export const SetPasswordDone = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-7 text-center" data-testid="set-password-done">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 shadow-neu-in">
        <CheckCircle2 className="h-11 w-11 text-emerald-600" />
      </div>
      <h2 className="mt-5 text-2xl font-black text-emerald-700">{t("reset.congrats")}</h2>
      <p className="mt-2 text-lg font-bold text-slate-800">{t("reset.done")}</p>
      <p className="mt-6 flex items-start gap-3 rounded-2xl bg-white/70 p-4 text-start text-base leading-relaxed text-slate-700 shadow-neu-in">
        <Smartphone className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
        {t("reset.openAppHint")}
      </p>
    </div>
  );
};
